import { createContext, type ReactNode, useContext } from "react";

/**
 * The only thing the marketing site knows about the signed-in user.
 *
 * Deliberately not the app's `User`: these pages need to know whether someone
 * is signed in (to swap "Get Started Free" for "Go to Dashboard") and which
 * plan they are on (to mark one as current). Importing the app's auth store to
 * learn that would put app code back in this bundle, which is the thing the
 * package split exists to prevent.
 *
 * The value is read once by the site entry in packages/frontend and handed in;
 * see SiteApp.
 */
export interface SiteUser {
  subscriptionTier?: "free" | "pro" | "team" | "enterprise";
}

const SessionContext = createContext<SiteUser | null>(null);

export function SessionProvider({
  user,
  children,
}: {
  user: SiteUser | null;
  children: ReactNode;
}) {
  return (
    <SessionContext.Provider value={user}>{children}</SessionContext.Provider>
  );
}

/** The signed-in user, or null. Null is the normal case on a marketing page. */
// eslint-disable-next-line react-refresh/only-export-components
export function useSiteUser(): SiteUser | null {
  return useContext(SessionContext);
}
